import { Button, Card, CardContent, CardDescription, CardHeader, CardTitle } from '@1trading/react';
import { LogOut } from 'lucide-react';
import { useSearchParams } from 'react-router-dom';
import { REAUTH_QUERY } from '@/lib/auth/auth-error';

const SignedOutPage = () => {
  const [searchParams] = useSearchParams();
  // Set when arriving from the sign-in error card's "start over" — see oidc-error.tsx.
  const forceReauth = searchParams.get('reauth') === '1';

  return (
    <div className="grid min-h-dvh place-items-center bg-background p-6">
      <Card className="w-full max-w-lg">
        <CardHeader>
          <div className="mb-2 flex items-center gap-2 text-muted-foreground">
            <LogOut aria-hidden className="size-5" />
            <span className="font-semibold">Signed out</span>
          </div>
          <CardTitle>You've signed out of BOP</CardTitle>
          <CardDescription>
            {forceReauth ? "You'll be asked to sign in to Okta again." : "You're still signed in to Okta, so signing back in won't ask for your password."}
          </CardDescription>
        </CardHeader>
        <CardContent>
          <Button asChild>
            <a href={forceReauth ? `/api/auth/login?${REAUTH_QUERY}` : '/api/auth/login'}>Sign in again</a>
          </Button>
        </CardContent>
      </Card>
    </div>
  );
};
SignedOutPage.displayName = 'SignedOutPage';

export default SignedOutPage;
